"use client"

import { useToast } from "@/components/ui/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <ToastProvider>
      {toasts.length > 0 && (
        <>
          {/* 遮罩层 */}
          <div
            className="fixed inset-0 z-[99] bg-black/50 backdrop-blur-sm transition-opacity animate-in fade-in-0"
            onClick={() => dismiss()}
          />
          {/* Toast内容 */}
          <ToastViewport className="!z-[100]" />
        </>
      )}
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
    </ToastProvider>
  )
}
